import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { IExecutor, IPosition, IRights, ISurveyAct, ISurveyActSigner } from './interfaces';

export const loadSurveyAct = (applicationNumber: string) => {
  return instance()
    .post<ISurveyAct | null>('/surveyAct/load', { applicationNumber })
    .then((response) => response.data);
};

export const getDefaultSigners = (applicationNumber: string) => {
  return instance()
    .post<ISurveyActSigner[]>('/surveyAct/defaultSigners', { applicationNumber })
    .then((response) => response.data);
};

export const createSurveyAct = (values: any) => {
  return instance()
    .post<ISurveyAct>('/surveyAct/create', values)
    .then((response) => response.data);
};

export const updateSurveyAct = (values: any) => {
  return instance()
    .post<ISurveyAct>('/surveyAct/update', values)
    .then((response) => response.data);
};

export const sendSurveyActToSigning = (applicationNumber: string, signature: string) => {
  return instance()
    .post<ISurveyAct>('/surveyAct/sendForSigning', { applicationNumber, signature })
    .then((response) => response.data);
};

export const signSurveyAct = (applicationNumber: string, signature: string) => {
  return instance()
    .post<ISurveyAct>('/surveyAct/sign', { applicationNumber, signature })
    .then((response) => response.data);
};

export const rejectSurveyAct = (applicationNumber: string, comment: string) => {
  return instance()
    .post<ISurveyAct>('/surveyAct/reject', { applicationNumber, comment })
    .then((response) => response.data);
};

export const revokeSurveyAct = (applicationNumber: string) => {
  return instance()
    .post<ISurveyAct>('/surveyAct/revoke', { applicationNumber })
    .then((response) => response.data);
};

export const getUserRights = (applicationNumber: string) => {
  return instance()
    .post<IRights>('/surveyAct/defineUserRights', { applicationNumber })
    .then((response) => response.data);
};

export const getDocument = (applicationNumber: string) => {
  return instance()
    .post('/surveyAct/generatePdf', { applicationNumber }, { responseType: 'blob' })
    .then((response) => response.data);
};

export const getApplicationExecutor = (applicationNumber: string) => {
  return instance()
    .post<IExecutor>('/application/getApplicationExecutor', { applicationNumber })
    .then((response) => response.data);
};

/** Должности инициатора по объекту заявки — те же справочники, что у Акта заключения */
export const getExecutorPositions = (realEstateGuid: string, config?: AxiosRequestConfig) => {
  return instance()
    .get<IPosition[]>('/executor/listExecutorPositions/' + realEstateGuid, config)
    .then((response) => response.data);
};

export const getUsers = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IExecutor[]>('/users/listPerformance', { search: config?.params.search }, config)
    .then((response) => response.data);
};
